import React, { createContext, useContext, useState } from 'react';
import { api } from 'app';

const PromotesUIContext = createContext();

export function usePromotesUIContext() {
  return useContext(PromotesUIContext);
}

export function PromotesUIProvider({ children }) {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);

  const fetchData = async query => {
    const q = query ? query.slice(1) : '';
    setIsLoading(true);
    api
      .get(`/evand-promot?${q}`)
      .then(response => {
        setData(response);
      })
      .catch(err => {
        console.log(err);
      });
    setIsLoading(false);
  };

  const value = {
    fetchData,
    data,
    setData,
    isLoading,
    setIsLoading
  };

  return <PromotesUIContext.Provider value={value}>{children}</PromotesUIContext.Provider>;
}
